import { inject, Service } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserDetails } from './types';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

const GRAPH_ME_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';

@Service()
export class UserService {
  readonly http = inject(HttpClient);

  getUserDetails = () => {
    return injectQuery(() => ({
      queryKey: ['userDetails'],
      queryFn: () =>
        lastValueFrom(
          this.http.get<UserDetails>(
            `${GRAPH_ME_ENDPOINT}?$select=id,displayName,department,userPrincipalName`,
          ),
        ),
    }));
  };

  getUserPhoto = () => {
    return injectQuery(() => ({
      queryKey: ['userPhoto'],
      queryFn: () =>
        lastValueFrom(
          this.http.get(`${GRAPH_ME_ENDPOINT}/photos/48x48/$value`, { responseType: 'blob' }),
        ),
    }));
  };
}
